/* Google "Add to preferred sources" button (footer, sections/pdp-footer.liquid).

   Google's publisher.js (~140KB, plus an iframe and gstatic bundles) is loaded
   by hand instead of via a <script async> in <head>:
     - only once theme tracking is allowed (window.__mmTrackingStarted /
       'mm:tracking-start' — California visitors must press Accept first), and
     - only when the footer is within ~600px of the viewport, so it never
       competes with first paint.
   Until then — or if the script is blocked — the plain deeplink pill next to
   it stays visible and works on its own. Once the button has drawn, the pill
   is hidden (.is-ready). The button draws into a shadow root, so it has no
   child nodes: readiness is detected by the host gaining height. */
(function () {
  var wrap = document.querySelector('[data-mm-pref-source]');
  if (!wrap || wrap.getAttribute('data-mm-pref-init')) return;
  wrap.setAttribute('data-mm-pref-init', '1');
  var host = wrap.querySelector('[google-add-preferred-source-btn]');
  if (!host) return;

  /* Phones (<680px): show the block in the bottom bar, under the card icons,
     instead of the brand column. It is one DOM node that is moved, never
     duplicated, so Google's button (and its shadow root) is only ever drawn
     once. A comment marks the brand-column home to move it back to. */
  var slot = document.querySelector('[data-mm-pref-slot]');
  if (slot && window.matchMedia) {
    var home = document.createComment('mm-pref-home');
    wrap.parentNode.insertBefore(home, wrap);
    var phone = window.matchMedia('(max-width: 679px)');
    var place = function () {
      if (phone.matches) { slot.appendChild(wrap); }
      else if (wrap.parentNode !== home.parentNode) { home.parentNode.insertBefore(wrap, home.nextSibling); }
    };
    place();
    if (phone.addEventListener) phone.addEventListener('change', place);
    else if (phone.addListener) phone.addListener(place);
  }

  var allowed = !!window.__mmTrackingStarted;
  var near = !('IntersectionObserver' in window);
  var started = false;

  function render() {
    if (started || !allowed || !near) return;
    started = true;
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        if (host.offsetHeight > 0) { wrap.classList.add('is-ready'); ro.disconnect(); }
      });
      ro.observe(host);
    }
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://news.google.com/swg/js/v1/publisher.js';
    document.head.appendChild(s);
  }

  if (!allowed) {
    document.addEventListener('mm:tracking-start', function () { allowed = true; render(); }, { once: true });
  }
  if (!near) {
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { near = true; io.disconnect(); render(); }
    }, { rootMargin: '600px 0px' });
    io.observe(wrap);
  }
  render();
})();
